import { colors } from '@amazd/common/static';
import { prependHexColor } from '@amazd/common/utils/color';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';

import useStyles from './styles';

export interface Props extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value?: string;
  onChange: (e: any) => void;
}

const ColorInput = ({ value, onChange, ...rest }: Props) => {
  const styles = useStyles();
  const bubbleColor = value || colors.grey20;
  return (
    <TextField
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" className={styles.adornment}>
            <span className={styles.colorBubble} style={{ background: prependHexColor(bubbleColor) }} />
          </InputAdornment>
        ),
      }}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
};

ColorInput.displayName = 'ColorInput';

export default ColorInput;
